import React from 'react';
import { Navigate } from 'react-router-dom';

const PrivateRoute = ({ children }) => {
    // 1. Check if the user is logged in
    const isLoggedIn = localStorage.getItem('token'); // Or however you store your login status

    // 2. If NOT logged in, kick them to the Login page ("/")
    if (!isLoggedIn) {
        return <Navigate to="/" replace />;
    }

    // 3. If logged in, let them see the page (children)
    return children;
};

export default PrivateRoute;


